import FormValidator from 'utils/form-validator';

export default class Login {
  constructor() {
    this.forms = document.querySelectorAll('.customers-login main form');
    this.forgotPwdBtn = document.querySelector('.customers-login .forgot-pwd');
    this.isResetPwdSuccess = document.querySelector('.customers-login .reset-password-success');
    this.registerBtn = document.querySelector('#create_customer input[type="submit"]');
    this.modal = document.querySelector('.customers-login .modal');
    this.modalContent = this.modal.querySelector('.content');
    this.closeModalBtn = this.modal.querySelector('.close-modal');

    this.forgotPwdBtn.addEventListener('click', this.showRecoverPwdForm.bind(this));
    $(document).on('click', '.forgot-pwd', (event) => {
      event.preventDefault();
      this.showRecoverPwdForm();
    });
    // this.registerBtn.addEventListener('click', () => sessionStorage.setItem('redirect-url', '/account'));
    this.modal.addEventListener('click', (e) => {
      this.closeModal(e.target);
    });
    this.modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    this.closeModalBtn.addEventListener('click', (e) => {
      let rootEl = e.target;

      // Find the root modal
      while (!rootEl.classList.contains('modal')) {
        rootEl = rootEl.parentElement;
      }

      this.closeModal(rootEl);
    });

    if (this.isResetPwdSuccess) {
      this.showRecoverPwdForm();
      this.modal.style.display = 'flex';
    }

    new FormValidator(document.getElementById('customer_login'), () => {
      console.log(arguments);
    });

    new FormValidator(document.getElementById('create_customer'), () => {
      console.log(arguments);
    });

    new FormValidator(document.getElementById('forgot_password'), () => {
      console.log(arguments);
    });
  }

  showRecoverPwdForm() {
    this.forms.forEach((form) => {
      form.classList.add('hidden');
    });

    document.getElementById('forgot_password').classList.remove('hidden');
  }

  closeModal(el) {
    el.classList.add('out');

    setTimeout(() => {
      el.style.display = 'none';
      el.classList.remove('out');
    }, 250);
  }
}
